import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, isSupported } from "firebase/messaging";

/**
 * Firebase Configuration
 * 
 * This file configures Firebase services for the YouthXConnect Events application.
 * Services include:
 * - Authentication (Firebase Auth)
 * - Database (Firestore)
 * - Push Notifications (Firebase Cloud Messaging via Cloudflare)
 * 
 * Enhanced with proper initialization to prevent useReducer errors
 */

const firebaseConfig = {
  apiKey: "AIzaSyAgkS-Wu_jy3zDC5ZhYa7A0X5Ze79gcnnE",
  authDomain: "youthxconnect-ptb.firebaseapp.com",
  projectId: "youthxconnect-ptb",
  storageBucket: "youthxconnect-ptb.firebasestorage.app",
  messagingSenderId: "357488100709",
  appId: "1:357488100709:web:c19e041f2cb45f03234d8c"
};

// Initialize Firebase app with error handling
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log('Firebase app initialized successfully');
} catch (error) {
  console.error('Error initializing Firebase app:', error);
  throw error;
}

// Initialize Firebase Auth with proper error handling
let auth;
try {
  auth = getAuth(app);
  
  // Ensure auth is ready before exporting
  auth.onAuthStateChanged((user) => {
    if (user) {
      console.log('User authenticated:', user.uid);
    } else {
      console.log('User not authenticated');
    }
  });
  
  console.log('Firebase Auth initialized successfully');
} catch (error) {
  console.error('Error initializing Firebase Auth:', error);
  throw error;
}

// Initialize Firestore with proper error handling
let db;
try {
  db = getFirestore(app);
  console.log('Firestore initialized successfully');
} catch (error) {
  console.error('Error initializing Firestore:', error);
  throw error;
}

// Initialize Firebase messaging only if supported (avoids errors in development)
let messaging = null;
if (typeof window !== 'undefined') {
  isSupported()
    .then((supported) => {
      if (supported) {
        try {
          messaging = getMessaging(app);
          console.log('Firebase Messaging initialized successfully');
        } catch (error) {
          console.error('Error initializing Firebase Messaging:', error);
        }
      } else {
        console.log('Firebase Messaging not supported in this environment');
      }
    })
    .catch((error) => {
      console.error('Error checking Firebase Messaging support:', error);
    });
}

/**
 * Get the messaging instance
 * @returns {Object|null} Firebase messaging instance or null if not supported
 */
export const getMessagingInstance = () => messaging;

// Export Firebase instances with proper initialization checks
export { auth, db };
export default app;
